/**
 * How far down from the top of the window a sticky bar covers the page (WCAG 2.2 2.4.11, Focus Not
 * Obscured): the page's top scroll padding, which the Level 2 bar sets to its height while it's on
 * the page. Something above this line is out of view even though it's inside the window. 0 when
 * there's no bar.
 */
export function coveredTop(): number {
  const padding = Number.parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop);
  return Number.isFinite(padding) ? padding : 0;
}
